import BankrateLogo from '@perpay-web/fintech/assets/images/bankrateLogo.svg';
import BestCreditOffersLogo from '@perpay-web/fintech/assets/images/bestCreditOffersLogo.svg';
import CreditCardsDotComLogo from '@perpay-web/fintech/assets/images/creditCardsDotComLogo.svg';
import CreditLandLogo from '@perpay-web/fintech/assets/images/creditLandLogo.svg';
import CreditSoupLogo from '@perpay-web/fintech/assets/images/creditSoupLogo.svg';
import experianLogo from '@perpay-web/fintech/assets/images/experianLogo.svg';
import KarmaLogo from '@perpay-web/fintech/assets/images/inputKarmaLogo.svg';
import moneyLionLogo from '@perpay-web/fintech/assets/images/moneyLionLogo.svg';
import PaychexLogo from '@perpay-web/fintech/assets/images/paychexLogo.svg';
import UberLogo from '@perpay-web/fintech/assets/images/uberLogo.svg';
import WalletHubLogo from '@perpay-web/fintech/assets/images/walletHubLogo.svg';
import {
    CREDIT_KARMA_LIGHTBOX,
    CREDIT_KARMA_INVITE_TO_APPLY,
    CREDIT_KARMA_LIGHTBOX_MKP,
    CREDIT_KARMA_INVITE_TO_APPLY_MKP,
    CREDIT_LAND,
    BEST_CREDIT_OFFERS,
    RED_VENTURES_BANKRATE,
    RED_VENTURES_BANKRATE_ITA,
    RED_VENTURES_CREDIT_CARDS_DOT_COM,
    RED_VENTURES_CREDIT_CARDS_DOT_COM_ITA,
    BULLDOG_CREDIT_SOUP,
    BULLDOG_CREDIT_SOUP_ITA,
    BULLDOG_CREDIT_SOUP_ITA_MKP,
    WALLET_HUB,
    WALLET_HUB_ITA,
    EXPERIAN_INVITE_TO_APPLY,
    EXPERIAN_ACTIVATE,
    MONEY_LION,
    MONEY_LION_ITA,
    MASTERCARD,
    PERPAY_WEBSITE,
    GOOGLE_SEARCH_ADS,
    INFLUENCER_PROMOTION,
    PERPAY_DIRECT_MAIL,
    OUT_OF_HOME_1,
    UBER,
    PAYCHEX,
} from '@perpay-web/fintech/constants/partnerOnboardingCodes';

export const getPartnerOnboardingLogo = (partnerCode) => {
    switch (partnerCode) {
        case CREDIT_KARMA_LIGHTBOX:
        case CREDIT_KARMA_INVITE_TO_APPLY:
        case CREDIT_KARMA_LIGHTBOX_MKP:
        case CREDIT_KARMA_INVITE_TO_APPLY_MKP:
            return {
                partnerLogo: KarmaLogo,
                partnerLogoClassName: 'credit-karma',
            };
        case CREDIT_LAND:
            return {
                partnerLogo: CreditLandLogo,
                partnerLogoClassName: 'credit-land',
            };
        case BEST_CREDIT_OFFERS:
            return {
                partnerLogo: BestCreditOffersLogo,
                partnerLogoClassName: 'best-credit-offers',
            };
        case RED_VENTURES_BANKRATE_ITA:
        case RED_VENTURES_BANKRATE:
            return {
                partnerLogo: BankrateLogo,
                partnerLogoClassName: 'bankrate',
            };
        case RED_VENTURES_CREDIT_CARDS_DOT_COM_ITA:
        case RED_VENTURES_CREDIT_CARDS_DOT_COM:
            return {
                partnerLogo: CreditCardsDotComLogo,
                partnerLogoClassName: 'credit-cards-dot-com',
            };
        case BULLDOG_CREDIT_SOUP_ITA:
        case BULLDOG_CREDIT_SOUP:
        case BULLDOG_CREDIT_SOUP_ITA_MKP:
            return {
                partnerLogo: CreditSoupLogo,
                partnerLogoClassName: 'credit-soup',
            };
        case WALLET_HUB_ITA:
        case WALLET_HUB:
            return {
                partnerLogo: WalletHubLogo,
                partnerLogoClassName: 'wallet-hub',
            };
        case EXPERIAN_ACTIVATE:
        case EXPERIAN_INVITE_TO_APPLY:
            return {
                partnerLogo: experianLogo,
                partnerLogoClassName: 'experian',
            };
        case MONEY_LION_ITA:
        case MONEY_LION:
            return {
                partnerLogo: moneyLionLogo,
                partnerLogoClassName: 'money-lion',
            };
        case MASTERCARD:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'mastercard',
            };
        case PERPAY_WEBSITE:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'perpay-website',
            };
        case GOOGLE_SEARCH_ADS:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'google-search-ads',
            };
        case INFLUENCER_PROMOTION:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'influencer-promotion',
            };
        case PERPAY_DIRECT_MAIL:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'perpay-direct-mail',
            };
        case OUT_OF_HOME_1:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'out-of-home',
            };
        case UBER:
            return {
                partnerLogo: UberLogo,
                partnerLogoClassName: 'uber',
            };

        case PAYCHEX:
            return {
                partnerLogo: PaychexLogo,
                partnerLogoClassName: 'paychex',
            };
        default:
            return {
                partnerLogo: null,
                partnerLogoClassName: '',
            };
    }
};

export const getPartnerNameFromCode = (partnerCode) => {
    switch (partnerCode) {
        case CREDIT_KARMA_LIGHTBOX:
            return 'CreditKarma LB';
        case CREDIT_KARMA_INVITE_TO_APPLY:
            return 'CreditKarma ITA';
        case CREDIT_LAND:
            return 'CreditLand';
        case BEST_CREDIT_OFFERS:
            return 'BestCreditOffers';
        case RED_VENTURES_BANKRATE:
            return 'Bankrate';
        case RED_VENTURES_BANKRATE_ITA:
            return 'Bankrate ITA';
        case RED_VENTURES_CREDIT_CARDS_DOT_COM:
            return 'CCDC';
        case RED_VENTURES_CREDIT_CARDS_DOT_COM_ITA:
            return 'CCDC ITA';
        case BULLDOG_CREDIT_SOUP_ITA:
        case BULLDOG_CREDIT_SOUP:
            return 'CreditSoup';
        case BULLDOG_CREDIT_SOUP_ITA_MKP:
            return 'Bulldog ITA Marketplace';
        case WALLET_HUB_ITA:
        case WALLET_HUB:
            return 'WalletHub';
        case EXPERIAN_INVITE_TO_APPLY:
            return 'Experian ITA';
        case EXPERIAN_ACTIVATE:
            return 'Experian Activate';
        case MONEY_LION:
            return 'MoneyLion';
        case MONEY_LION_ITA:
            return 'MoneyLion ITA';
        case MASTERCARD:
            return 'Mastercard';
        case PERPAY_WEBSITE:
            return 'Perpay Website';
        case GOOGLE_SEARCH_ADS:
            return 'Google Search Ads';
        case INFLUENCER_PROMOTION:
            return 'Influencer Promotion';
        case PERPAY_DIRECT_MAIL:
            return 'Perpay Direct Mail';
        case OUT_OF_HOME_1:
            return 'Out of Home Marketing';
        case UBER:
            return 'Uber';
        default:
            return null;
    }
};
